import PropTypes from 'prop-types'
import AR from './img/AR.png'
import BOL from './img/BOL.png'
import BR from './img/BR.png'
import CH from './img/CH.png'
import MX from './img/MX.png'
import PRY from './img/PRY.png'
import URU from './img/URU.png'

const banderas = [
  { title: 'AR', img: AR },
  { title: 'BOL', img: BOL },
  { title: 'BR', img: BR },
  { title: 'MX', img: MX },
  { title: 'PRY', img: PRY },
  { title: 'URU', img: URU },
  { title: 'CH', img: CH }
]

const Banderas = (props) => {
  return (
    <div className="row">
      <div className="col text-right">
        {banderas.map((bandera) => (
          <img
            key={bandera.title}
            onClick={() => props.traerDatos(bandera.title)}
            src={bandera.img}
            alt={bandera.title}
            title={bandera.title}
            className="banderas-paises"
          />
        ))}
      </div>
    </div>
  )
}

Banderas.propTypes = {
  traerDatos: PropTypes.func.isRequired
}

export default Banderas
